import React, { useEffect, useState } from "react";
import { Form, InputNumber, Select, Input } from "antd";
import i18n from "../../i18n";

export default function BitInputField({ name, label, priceDelivery, setPrice, setPaymentType, min = 0, max = undefined, getFieldErrors, keyNum, delivery }) {
	const fieldErrors = (typeof keyNum !== "undefined") ? getFieldErrors(name, keyNum) : getFieldErrors(name);
	const { Option } = Select;

	const [selectedPaymentType, setSelectedPaymentType] = useState(1);
	const [currentPrice, setCurrentPrice] = useState(1);

	const types = [
		{ key: 1, class: 'bit-1', title: "NdsPrice", value: delivery.NdsPrice, name: i18n.t('components.BitInputField.NdsPrice') },
		{ key: 2, class: 'bit-2', title: 'NoNdsPrice', value: delivery.NoNdsPrice, name: i18n.t('components.BitInputField.NoNdsPrice') },
		{ key: 3, class: 'bit-3', title: "CashPrice", value: delivery.CashPrice, name: i18n.t('components.BitInputField.CashPrice') },

		{ key: 4, class: 'bit-4', title: "EuroPrice", value: delivery.EuroPrice, name: i18n.t('components.BitInputField.EuroPrice') },
		{ key: 5, class: 'bit-5', title: "DollarPrice", value: delivery.DollarPrice, name: i18n.t('components.BitInputField.DollarPrice') },

		{ key: 6, class: 'bit-6', title: "BelarusRubNdsPrice", value: delivery.BelarusRubNdsPrice, name: i18n.t('components.BitInputField.BelarusRubNdsPrice') },
		{ key: 7, class: 'bit-7', title: "BelarusRubNoNdsPrice", value: delivery.BelarusRubNoNdsPrice, name: i18n.t('components.BitInputField.BelarusRubNoNdsPrice') },
	];

	// types.sort(function (a, b) {
	// 	return a.value - b.value;
	// });

	// types.forEach((element, index) => {
	// 	if (element.value == 0) {
	// 		types[index].value = '-';
	// 	} else {
	// 		inputDeefaultValue = element.value;
	// 		selectDefaultValue = element.key
	// 	}
	// })

	// types.sort(function (a, b) {
	// 	a.value = a.value == '-' ? 0 : a.value;
	// 	b.value = b.value == '-' ? 0 : b.value;
	// 	return b.value - a.value;
	// });

    // useEffect(() => {
    //     const price = delivery.Prices.find(e => e.Price !== null);
    //     if (price) {
    //         setPrice(price.Price);
    //         setSelectedPaymentType(price.PaymentType.Id);
    //         setCurrentPrice(price.Price);
    //     }
    // }, [delivery])


	useEffect(function () {
		// Проверяем наличие delivery и Prices
		if (delivery && delivery.Prices && delivery.Prices.length > 0) {
			// Находим первую цену, которая не null
			var price = null;
			for (var i = 0; i < delivery.Prices.length; i++) {
				if (delivery.Prices[i].Price !== null) {
					price = delivery.Prices[i];
					break;
				}
			}

			if (price) {
				setPrice(price.Price);
				setSelectedPaymentType(price.PaymentType.Id);
				setCurrentPrice(price.Price);
			} else {
				// Если все цены null - берем первую
				var firstPrice = delivery.Prices[0];
				setSelectedPaymentType(firstPrice.PaymentType.Id);
				setCurrentPrice(null);
			}
		}
	}, [delivery]);

	const onChange = (price) => {
		if (price == null) {
			price = 0;
		}
		setPrice(price);
    setCurrentPrice(price);
		priceDelivery = price;
	};

	const onClickSetPayment = (value) => {
		setPaymentType(value);
	}

	if (fieldErrors) {
		return (
			<React.Fragment>
				<span className="form-field-label" htmlFor={name}>
					{label}
				</span>
				<Form.Item validateStatus="error" help={fieldErrors}>
					<Input.Group compact>
						<InputNumber
							min={0}
							max={max}
							size="large"
							name={name}
							id={name}
							onChange={onChange}
							placeholder={label}
							value={priceDelivery}
							disabled={delivery.IsMulticost}
							style={{ width: "60%" }}
							//formatter={value => `₽ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
							//parser={value => value.replace(/\₽\s?|(,*)/g, '')}
						/>
						<Select onChange={onClickSetPayment} value={selectedPaymentType} className="bit-item" size="large" style={{width: "40%", fontFamily: "Montserrat", fontStyle: "normal", fontWeight: "normal", fontSize: "13px", lineHeight: "12px" }}>
                            {delivery.Prices.map((type) => {
                                return (<Option key={type.PaymentType.Id} value={type.PaymentType.Id}>{type.PaymentType.Title}</Option>);
                            })}
						</Select>

						<p className="bit-label">
                            {delivery.Prices.map((type) => {
                                return (
                                    <span className="bit-1">{type.PaymentType.Title}: <b className="bit-value">{type.Price}</b></span>
                                );
                            })}
						</p>
					</Input.Group>
				</Form.Item>
			</React.Fragment>
		);
	} else {
		return (
			<React.Fragment>
				<span className="form-field-label" htmlFor={name}>
					{label}
				</span>
				<Input.Group compact>
					<InputNumber
						min={min}
						max={max}
						size="large"
						name={name}
						id={name}
						onChange={onChange}
						placeholder={label}
						disabled={delivery.IsMulticost}
            value={priceDelivery}
						style={{ width: "60%" }}
						//formatter={value => `₽ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
						//parser={value => value.replace(/\₽\s?|(,*)/g, '')}
					/>

					<Select
              onChange={onClickSetPayment}
			  value={selectedPaymentType || (delivery && delivery.Prices && delivery.Prices[0] && delivery.Prices[0].PaymentType && delivery.Prices[0].PaymentType.Id)}
              className="bit-item"
              size="large"
              onSelect={(value => setSelectedPaymentType(value))}
              style={{ width: "40%", fontFamily: "Montserrat", fontStyle: "normal", fontWeight: "normal", fontSize: "13px", lineHeight: "12px" }}
          >
						{delivery.Prices.map((type) => {
						    return (<Option key={type.PaymentType.Id} value={type.PaymentType.Id}>{type.PaymentType.Title}</Option>);
						})}
					</Select>

					<p className="bit-label">
                        {delivery.Prices.map((type,index) => {
                            return (
                                <span className="bit-1" key={`payment-type-${index}`}>{type.PaymentType.Title}: <b className="bit-value">{type.Price}</b></span>
                            );
                        })}
					</p>
				</Input.Group>
			</React.Fragment>
		);
	}
}
